import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Modal } from 'react-native';

export interface ProfileModalProps {
  visible: boolean;
  title?: string;
  message?: string;
  cancelText?: string;
  confirmText?: string;
  onCancel?: () => void;
  onConfirm?: () => void;
}

const ProfileModal: React.FC<ProfileModalProps> = ({ 
  visible, 
  title, 
  message, 
  cancelText = 'Cancel',
  confirmText = 'Confirm',
  onCancel, 
  onConfirm 
}) => {
  return (
    <Modal visible={visible} transparent animationType="fade" onRequestClose={onCancel}>
      <View style={styles.overlay}>
        <View style={styles.container}>
          <View style={styles.header}><Text style={styles.title}>{title}</Text></View>
          <View style={styles.content}><Text style={styles.message}>{message}</Text></View>
          <View style={styles.actions}>
            <TouchableOpacity style={styles.btn} onPress={onCancel}><Text style={styles.cancelTextStyle}>{cancelText}</Text></TouchableOpacity>
            <TouchableOpacity style={styles.btn} onPress={onConfirm}><Text style={styles.confirmTextStyle}>{confirmText}</Text></TouchableOpacity>
          </View>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  overlay: { flex: 1, backgroundColor: 'rgba(0,0,0,0.3)', justifyContent: 'center', alignItems: 'center', padding: 20 },
  container: { width: '100%', maxWidth: 360, backgroundColor: '#fff', borderRadius: 12, overflow: 'hidden' },
  header: { padding: 16, borderBottomWidth: 1, borderBottomColor: '#f1f1f1' },
  title: { fontSize: 18, fontWeight: '700', textAlign: 'center' },
  content: { padding: 16 },
  message: { fontSize: 15, color: '#666', textAlign: 'center' },
  actions: { flexDirection: 'row', borderTopWidth: 1, borderTopColor: '#f1f1f1' },
  btn: { flex: 1, paddingVertical: 14, alignItems: 'center' },
  cancelTextStyle: { color: '#666' },
  confirmTextStyle: { color: '#2563EB', fontWeight: '700' },
});

export default ProfileModal;
